import {useMemo} from 'react';
import Box from '@mui/material/Box';
import {useTranslation} from 'react-i18next';

const NUMBER = /(\d[\d.,]*\d|\d)/;

// Translations interpolate the raw count, so numbers are grouped per locale ("2,567" / "2.567") here.
const BoldNumbers = ({text}: {text: string}) => {
    const {i18n} = useTranslation();
    const language = i18n?.resolvedLanguage || i18n?.language;
    const numbers = useMemo(() => new Intl.NumberFormat(language), [language]);

    return (
        <>
            {text.split(NUMBER).filter(Boolean).map((part, index) => /^\d/.test(part)
                ? (
                    <Box key={index} component={'span'} sx={{fontWeight: 600, fontVariantNumeric: 'tabular-nums'}}>
                        {/^\d+$/.test(part) ? numbers.format(Number(part)) : part}
                    </Box>
                )
                : part)}
        </>
    );
};

export default BoldNumbers;
